import { useState, useEffect } from "react";
import { getRubrics } from "../../../services/api/job";
import { Rubric } from "../../../store/types/job";

export const useRubrics = () => {
  const [rubrics, setRubrics] = useState<Rubric[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRubrics = async () => {
    setLoading(true);
    try {
      const response = await getRubrics();
      setRubrics(response.data);
      setError(null);
    } catch (err: any) {
      setError(err.message || "An error occurred while fetching rubrics");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRubrics();
  }, []);

  return { rubrics, loading, error, refetch: fetchRubrics };
};
